import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FileUploader from "components/MediaTel/FileUploader";
import FileViewer from "components/MediaTel/FileViewer";
import Button from "@mui/material/Button";

import classnames from "classnames";
import Loader from "components/Loading/Loader";
import {
  appdataSelector,
  appdata_getVendorsForCompany,
  appdata_getPOsForVendor,
  appdata_setSnackbar,
  appdata_setActiveRequestType,
  appdata_setActiveRequestState,
  appdata_setActiveRequestID
} from "reducers/appdata/appdata";
import {
  vendordataSelector,
  vendordata_clearAllVendorData,
  vendordata_updateActiveVendor,
  vendor_save_to_sap,
  vendordata_setSavedToSAP
} from "reducers/vendordata/vendordata";
import { renderDropdown } from "components/MediaTel/DropdownAutoComplete";
import { useNavigate } from "react-router";
import Feedback from "../../partials/Feedback";

function Change() {
  const appdata = useSelector(appdataSelector);
  const vendordata = useSelector(vendordataSelector);
  const dispatch = useDispatch();


  const [companySelected, setCompanySelected] = useState(null);
  const [vendorSelected, setVendorSelected] = useState(null);



  useEffect(() => {
    console.log("NEW Change");

    if (!appdata.isResetRequest) {
      dispatch(vendordata_clearAllVendorData());
      dispatch(appdata_setActiveRequestID(null));
    }

    if (appdata.activeRequestType != appdata.requestTypes.CHANGE_VENDOR) {
      dispatch(
        appdata_setActiveRequestType(appdata.requestTypes.CHANGE_VENDOR)
      );
    }

    if (appdata.activeRequestState != appdata.requestStates.CREATE) {
      dispatch(appdata_setActiveRequestState(appdata.requestStates.CREATE));
    }

    if (vendordata.savedToSAP) {
      dispatch(vendordata_setSavedToSAP(false));
    }
  }, []);




  useEffect(() => {

    if (vendordata.activeVendor.master) {
      if (appdata && appdata.listvalues) {
        if (appdata.listvalues.companyDropdownValues) {
          appdata.listvalues.companyDropdownValues.map((item, key) => {
            if (item["BUKRS"] === vendordata.activeVendor.master.BUKRS) {
              if (!companySelected || companySelected["BUKRS"] != item["BUKRS"]) {
                setCompanySelected(item);
                dispatch(appdata_getVendorsForCompany(item["BUKRS"]));
              }
            }
          });
        }

        if (
          appdata.listvalues.vendorsForCompany &&
          Object.keys(appdata.listvalues.vendorsForCompany).length > 0
        ) {
          appdata.listvalues.vendorsForCompany.map((item, key) => {
            if (item["LIFNR"] === vendordata.activeVendor.master.LIFNR) {
              if (!vendorSelected || vendorSelected["LIFNR"] != item["LIFNR"]) {
                setVendorSelected(item);
                if (companySelected)
                  dispatch(appdata_getPOsForVendor(companySelected["BUKRS"], item["LIFNR"]))
              }
            }
          });
        }
      }
    }
    else{
      if (companySelected) setCompanySelected("");
      if (vendorSelected) setVendorSelected("");
    }
  }, [vendordata.activeVendor, appdata.listvalues])


  let POSelected = "";
  if (vendordata.activeVendor.master) {

    if (
      appdata.listvalues.POsForVendor &&
      Object.keys(appdata.listvalues.POsForVendor).length > 0
    ) {
      appdata.listvalues.POsForVendor.map((item, key) => {
        if (item["EKORG"] === vendordata.activeVendor.master.EKORG)
          POSelected = item;
      });
    }
  }


  const handleSelectChange = (value, type = null) => {
    console.log("handle select change", value, type);

    if (type == "BUKRS") {
      // company selected

      // clean active vendor
      if (!appdata.isResetRequest) {
        dispatch(vendordata_clearAllVendorData());
      }
      else {
        // set current company
        dispatch(
          vendordata_updateActiveVendor({
            part: "master",
            key: "LIFNR",
            value: ""
          })
        );
      }

      // get vendors for company
      dispatch(appdata_getVendorsForCompany(value));
    }

    if (type == "LIFNR") {
      dispatch(appdata_getPOsForVendor(companySelected.BUKRS, value));
    }

    // set current company
    dispatch(
      vendordata_updateActiveVendor({
        part: "master",
        key: type,
        value: value
      })
    );
  };

  const showVendorDropdown = () => {
    if (
      companySelected &&
      appdata.listvalues.vendorsForCompany &&
      Object.keys(appdata.listvalues.vendorsForCompany).length > 0
    ) {
      return true;
    }
    return false;
  };

  const showNOPOsWarning = () => {
    if (
      companySelected &&
      vendorSelected &&
      appdata.listvalues.POsForVendor &&
      Object.keys(appdata.listvalues.POsForVendor).length > 0 &&
      appdata.listvalues.POsForVendor[0]["EKORG"] == ""
    ) {
      return true;
    }
    return false;
  };
  const showPOsDropdown = () => {
    if (
      companySelected &&
      vendorSelected &&
      appdata.listvalues.POsForVendor &&
      Object.keys(appdata.listvalues.POsForVendor).length > 0 &&
      appdata.listvalues.POsForVendor[0]["EKORG"] != ""
    ) {
      return true;
    }
    return false;
  };

  const allowSave = () => {
    if (
      vendordata.activeVendor.master &&
      vendordata.activeVendor.master.BUKRS &&
      vendordata.activeVendor.master.LIFNR &&
      ((showPOsDropdown() && vendordata.activeVendor.master.EKORG) || showNOPOsWarning()) &&
      Object.keys(vendordata.files).length > 0
    ) {
      return true;
    }
    return false;
  };

  const handleSave = () => {
    dispatch(appdata_setSnackbar({ open: true, message: "Saving..." }));

    dispatch(vendor_save_to_sap());
  };

  let containerClass = "no-breadcrumb chapter mt-4";
  if (!appdata.isResetRequest) {
    containerClass += " container-fluid"
  }


  if (vendordata.savedToSAP) {
    return (
      <Feedback header="Change Vendor"></Feedback>
    );
  }

  return (
    <article className="article">
      <div className={containerClass}>

        {!appdata.isResetRequest && (
          <h2 className="article-title">Change Vendor</h2>
        )}

        {appdata.isResetRequest && (
          <React.Fragment>
            <h2 className="article-title">
              Update Request
            </h2>
            <div className="mt-2">
              <b>Message: {vendordata.activeVendor.master.ZCOMMENT}</b>
            </div>
          </React.Fragment>
        )}

        <div className="mt-4">
          {/* company */}
          {/* company */}
          {/* company */}
          {/* company */}
          {renderDropdown(
            "Company",
            appdata.listvalues.companyDropdownValues,
            companySelected,
            "BUKRS",
            "BUKRS",
            ["BUKRS", "BUTXT"],
            handleSelectChange
          )}

          {/* vendor */}
          {/* vendor */}
          {/* vendor */}
          {/* vendor */}
          {showVendorDropdown() &&
            renderDropdown(
              "Vendor",
              appdata.listvalues.vendorsForCompany,
              vendorSelected,
              "LIFNR",
              "LIFNR",
              ["LIFNR", "NAME1"],
              handleSelectChange
            )}

          {/* no purchasing organistations warning */}
          {/* no purchasing organistations warning */}
          {/* no purchasing organistations warning */}
          {/* no purchasing organistations warning */}
          {showNOPOsWarning() && (
            <div className="mt-4">
              {" "}
              No Purchasing organisations found for vendor{" "}
            </div>
          )}

          {/* purchasing organisations */}
          {/* purchasing organisations */}
          {/* purchasing organisations */}
          {/* purchasing organisations */}
          {showPOsDropdown() &&
            renderDropdown(
              "Purchasing organisation",
              appdata.listvalues.POsForVendor,
              POSelected,
              "EKORG",
              "EKORG",
              ["EKORG", "EKOTX"],
              handleSelectChange
            )}

          {/* fileuploader */}
          {/* fileuploader */}
          {/* fileuploader */}
          {/* fileuploader */}
          {/* fileuploader */}
          {(showPOsDropdown() || showNOPOsWarning()) && <FileUploader></FileUploader>}

          {/* fileViewer */}
          {/* fileViewer */}
          {/* fileViewer */}
          {/* fileViewer */}
          {/* fileViewer */}
          {(showPOsDropdown() || showNOPOsWarning()) && <FileViewer enableRemove={appdata.isResetRequest}></FileViewer>}

          {/* save button */}
          {/* save button */}
          {/* save button */}
          {/* save button */}
          {allowSave() && !vendordata.saving && (
            <Button
              className={classnames("besiButton", "d-print-none", "mt-5")}
              variant="contained"
              key="savebutton"
              onClick={() => handleSave()}
            >
              Save
            </Button>
          )}

          {/* loader when saving */}
          {/* loader when saving */}
          {/* loader when saving */}
          {/* loader when saving */}
          {/* loader when saving */}
          {vendordata.saving && (
            <div className="mt-4">
              <Loader size="30"></Loader>
            </div>
          )}
        </div>
      </div>
    </article>
  );
}
export default Change;
